import { useEffect } from "react";
import { useMap } from "react-leaflet";

function scheduleInvalidate(map) {
    const delays = [0, 50, 150, 400];
    const timers = delays.map((delay) => window.setTimeout(() => {
        map.invalidateSize({ animate: false });
    }, delay));
    return () => timers.forEach((id) => window.clearTimeout(id));
}

export default function InvalidateMapSizeWhenVisible({ isVisible = true }) {
    const map = useMap();

    useEffect(() => {
        if (!isVisible) return undefined;
        return scheduleInvalidate(map);
    }, [map, isVisible]);

    useEffect(() => {
        if (!isVisible) return undefined;

        const container = map.getContainer();
        if (!container || typeof ResizeObserver === "undefined") return undefined;

        const observer = new ResizeObserver(() => {
            map.invalidateSize({ animate: false });
        });
        observer.observe(container);

        return () => observer.disconnect();
    }, [map, isVisible]);

    return null;
}
